module.exports = __webpack_public_path__ + "static/media/clockInLogo_2.49ad5fc6.png";